import {
  SUPPORT_FILE_EXTENSIONS,
  SUPPORT_MAX_FILE_BYTES,
  SUPPORT_MAX_FILES,
} from "../constants/support";

const extensionOf = (name) => {
  const dot = (name || "").lastIndexOf(".");
  return dot === -1 ? "" : name.slice(dot).toLowerCase();
};

/**
 * Check a pick against the server's limits before uploading anything.
 * Returns an i18n key for the first problem, or null when the batch is fine.
 * `current` is how many files are already attached to the draft.
 */
export function supportFilesProblem(files, current = 0) {
  if (current + files.length > SUPPORT_MAX_FILES) return "support.errors.tooManyFiles";
  for (const file of files) {
    if (!SUPPORT_FILE_EXTENSIONS.includes(extensionOf(file.name))) {
      return "support.errors.badFileType";
    }
    if (file.size > SUPPORT_MAX_FILE_BYTES) return "support.errors.fileTooLarge";
  }
  return null;
}

export const isImageFile = (file) => (file?.type || "").startsWith("image/");

/**
 * A multipart body for the support endpoints. Arrays (the `files` list) go up
 * as repeated keys, which is what DRF's ListField reads back.
 */
export function supportFormData(body) {
  const data = new FormData();
  Object.entries(body).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) value.forEach((item) => data.append(key, item));
    else data.append(key, value);
  });
  return data;
}

export function formatFileSize(bytes) {
  if (!Number.isFinite(bytes)) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
